define([
    'text!common/toast/loading.html',
    'css!vendor/weui/weui.min.css'
], function(
    tpl
){
    return {
        template: tpl
    }
});


//////////////////
// WEBPACK FOOTER
// ./common/toast/loading.js
// module id = 93
// module chunks = 0 1 2 3 4 5 6 7 8